/*
 * Created Date: 23-09-2022, 11:44:38 pm
 * Author: TheAnh58
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

// import { APP_UAA_URL } from 'env'
import { get, startsWith } from 'lodash'
import { LOCAL_STORAGE, SESSION_STORAGE, getAuthTokenSession, getDataSession } from './Session'

export function isLocalhost() {
	return (
		typeof window === 'object' &&
		(window.location.origin.indexOf('localhost') > -1 || window.location.origin.indexOf('127.0.0.1') > -1)
	)
}

export const isStudioProduction = () => {
	return (
		window.location.origin.indexOf('studio.eduquiz.vn') > -1 ||
		window.location.origin.indexOf('studio.eduquiz.io.vn') > -1 ||
		window.location.origin.indexOf('studio-v2.eduquiz.vn') > -1
	)
}

export const isSiteUat = () => {
	return typeof window === 'object' && window.location.origin.indexOf('studio-uat.eduquiz.vn') > -1
}

export const isSiteDev = () => {
	return typeof window === 'object' && window.location.origin.indexOf('dev.eduquiz.vn') > -1
}

export const isStudioDev = () => {
	return typeof window === 'object' && window.location.origin.indexOf('studio-dev-v2.vercel.app') > -1
}

export const redirectUrl = (app, target) => {
	const authToken = getAuthTokenSession()
	let url = ''

	if (app === 'eduquiz') {
		url = isLocalhost() || isSiteDev() ? `https://dev.eduquiz.vn/` : `https://eduquiz.vn/`
	} else if (app === 'studio') {
		url = isLocalhost() || isSiteDev() ? `https://studio-dev.eduquiz.vn/` : `https://studio.eduquiz.vn/`
	} else if (startsWith(app, 'http') || startsWith(app, 'https')) {
		url = app
	}
	if (authToken) {
		url += `?access_token=${authToken?.access_token}&tokenType=${authToken?.token_type}`
	}

	window.location.href = url
}

// export const URL_UPLOAD_FILE = 'https://pesthubt.s3-ap-southeast-1.amazonaws.com'
export const URL_UPLOAD_FILE = 'https://dev-eduquiz.s3-ap-southeast-1.amazonaws.com'

export const getS3Url = path => {
	const URL_FILE_S3 = getDataSession(LOCAL_STORAGE, 'system_general')?.s3_url

	if (startsWith(path, 'http') || startsWith(path, 'https')) {
		return path
	}
	if (startsWith(path, 'workspace/')) {
		return getMinioUrl(path)
	}

	if (startsWith(path, '/')) {
		return `${URL_FILE_S3}${path}`
	}

	return path ? `${URL_FILE_S3}/${path.replace('Câu ', 'Ca%CC%82u+')}` : path
}

export const getMinioUrl = path => {
	const URL_FILE_MINIO =
		getDataSession(LOCAL_STORAGE, 'system_general')?.minio_url ?? 'http://103.176.178.156:9000/dev-eduquiz'

	if (startsWith(path, 'http') || startsWith(path, 'https')) {
		return path
	}
	if (startsWith(path, '/')) {
		return `${URL_FILE_MINIO}${path}`
	}

	return path ? `${URL_FILE_MINIO}/${path}` : path
}

export const convertUrlWithParams = (url, obj = {}) => {
	const query = Object.keys(obj)
		.filter(key => get(obj, key))
		.map(key => {
			return `${key}=${obj[key]}`
		})
	if (query.length > 0) {
		return `${url}?${query.join('&')}`
	}
	return url
}

export const getQueryUrlObject = key => {
	const result = {}
	if (typeof window !== 'undefined') {
		const params = new URLSearchParams(window.location.search)

		// eslint-disable-next-line
		for (let entry of params) {
			// each 'entry' is a [key, value] tupple
			const [key, value] = entry
			result[key] = value
		}
		if (key) {
			return get(result, key)
		}
	}

	return result
}
//

export const redirectUaaLogin = url => {
	let backUrl = window.location.href

	if (url) {
		backUrl =
			startsWith(url, 'http') || startsWith(url, 'https')
				? url
				: startsWith(url, '/')
				? window.location.origin + url
				: `${window.location.origin}/${url}`
	} else if (window.location.pathname === '/user/login' || window.location.pathname === '/user/register') {
		backUrl = window.location.origin
	}

	// return window.location.replace(`${APP_UAA_URL}/login?backToApp=studio&backUrl=${backUrl}`)
}
